module.exports = __webpack_public_path__ + "static/media/4-focus.bdc70188.svg";